<template>
  <svg
    xlmns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d" fill-rule="evenodd" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';

import { rgeoToPolygon } from '@/functions/geospatial_conversions';
import { generateSvgPaths } from '@/functions/svg_polygon';

const props = defineProps({
  bounds: { type: String, required: true },
  size: { type: Number, default: 20 },
  padding: { type: Number, default: 1 },
  project: { type: Boolean, default: true },
});

const polygon = computed(() => {
  if (!props.bounds) return null;

  return rgeoToPolygon(props.bounds);
});

const paths = computed(() => {
  let paths = [];
  if (polygon.value) {
    paths = generateSvgPaths(polygon.value, {
      scale: props.size,
      padding: props.padding,
      project: props.project
    });
  }
  return paths;
});
</script>
